import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import checkIcon from '../assets/check.svg';
// import coins1 from '../assets/coins1.svg';
// import coins2 from '../assets/coins2.svg';
// import coins3 from '../assets/coins3.svg';
import arrowDown from '../assets/arrow-down.svg';
import profileImage from '../assets/profile.png';

import svgPaths from "./svg-v1s1r2oes5";

function Group597() {
  return (
    <div className="relative size-full">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 20 10">
        <g id="Group 597">
          <path d={svgPaths.p36223460} fill="var(--fill-0, #FFCF4D)" id="Vector" />
          <path d={svgPaths.p30604c00} fill="var(--fill-0, #FFCF4D)" id="Vector_2" />
          <path d={svgPaths.paf1580} fill="var(--fill-0, #FFDD80)" id="Vector_3" />
          <path d={svgPaths.p1ecfc200} fill="var(--fill-0, #FFCF4D)" id="Vector_4" />
          <path d={svgPaths.p3aa971f0} fill="var(--fill-0, #FFE7A7)" id="Vector_5" />
          <path d={svgPaths.p31fb5980} fill="var(--fill-0, #FFCF4D)" id="Vector_6" />
          <path d={svgPaths.pc0a2f00} fill="var(--fill-0, #FFDD80)" id="Vector_7" />
        </g>
      </svg>
    </div>
  );
}

function Group598() {
  return (
    <div className="relative size-full">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 20 10">
        <g id="Group 598">
          <path d={svgPaths.p20db5380} fill="var(--fill-0, #FFCF4D)" id="Vector" />
          <path d={svgPaths.p14e3ff80} fill="var(--fill-0, #FFCF4D)" id="Vector_2" />
          <path d={svgPaths.p36537800} fill="var(--fill-0, #FFDD80)" id="Vector_3" />
          <path d={svgPaths.p37aeeb80} fill="var(--fill-0, #FFCF4D)" id="Vector_4" />
          <path d={svgPaths.p15abcb00} fill="var(--fill-0, #FFE7A7)" id="Vector_5" />
          <path d={svgPaths.p46f3c00} fill="var(--fill-0, #FFCF4D)" id="Vector_6" />
          <path d={svgPaths.p1de57500} fill="var(--fill-0, #FFDD80)" id="Vector_7" />
        </g>
      </svg>
    </div>
  );
}

function Group599() {
  return (
    <div className="relative size-full">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 20 10">
        <g id="Group 599">
          <path d={svgPaths.p20db5380} fill="var(--fill-0, #FFCF4D)" id="Vector" />
          <path d={svgPaths.p3c92ce00} fill="var(--fill-0, #FFCF4D)" id="Vector_2" />
          <path d={svgPaths.p9110300} fill="var(--fill-0, #FFDD80)" id="Vector_3" />
          <path d={svgPaths.p201e8b00} fill="var(--fill-0, #FFCF4D)" id="Vector_4" />
          <path d={svgPaths.p326dbe10} fill="var(--fill-0, #FFE7A7)" id="Vector_5" />
          <path d={svgPaths.p83a4bf0} fill="var(--fill-0, #FFCF4D)" id="Vector_6" />
          <path d={svgPaths.p1a95b780} fill="var(--fill-0, #FFDD80)" id="Vector_7" />
        </g>
      </svg>
    </div>
  );
}

function Group600() {
  return (
    <div className="relative size-full">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 37 19">
        <g id="Group 600">
          <path d={svgPaths.p2d97af00} fill="var(--fill-0, #FFCF4D)" id="Vector" />
          <path d={svgPaths.pcf5fc80} fill="var(--fill-0, #FFCF4D)" id="Vector_2" />
          <path d={svgPaths.p36bcb900} fill="var(--fill-0, #FFDD80)" id="Vector_3" />
          <path d={svgPaths.pb0ea400} fill="var(--fill-0, #FFCF4D)" id="Vector_4" />
          <path d={svgPaths.p33c1f180} fill="var(--fill-0, #FFE7A7)" id="Vector_5" />
          <path d={svgPaths.p1dc8ff00} fill="var(--fill-0, #FFCF4D)" id="Vector_6" />
          <path d={svgPaths.p23da1680} fill="var(--fill-0, #FFDD80)" id="Vector_7" />
        </g>
      </svg>
    </div>
  );
}

const Screen3: React.FC = () => {
  const navigate = useNavigate();

  return (
    <motion.div
      className="w-full h-[100dvh] bg-[#f0effa] relative overflow-y-auto overscroll-contain"
      onClick={() => navigate('/screen4')}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.4 }}
    >
      {/* Title */}
      <div className="absolute top-[44px] left-1/2 -translate-x-1/2 w-full text-center">
        <h1 className="text-[#221a51] text-[45px] leading-[45px] font-medium font-['Bricolage_Grotesque',_sans-serif]">
          Your Options
        </h1>
      </div>

      {/* Debt Consolidation Card (Purple) */}
      <motion.div className="absolute left-[21px] top-[124px] w-[348px] h-[159px]">
        <motion.div
          className="relative w-full h-full bg-[#9b86ea] rounded-[38.631px] border-[0.966px] border-black shadow-[5.795px_5.795px_0px_0px_#221a51]"
          initial={{ y: 10, scale: 0.98, opacity: 0 }}
          animate={{ y: 0, scale: 1, opacity: 1 }}
          transition={{ delay: 0.15, type: 'spring', stiffness: 140, damping: 12 }}
          whileHover={{ y: -2, rotate: -0.5 }}
          whileTap={{ scale: 0.995 }}
        >
          {/* Check Badge */}
          <div className="absolute left-[13px] top-[63px] w-[34px] h-[34px] bg-[#221a51] rounded-full flex items-center justify-center">
            <img src={checkIcon} alt="" className="w-[21.636px] h-[21.636px]" />
          </div>

          {/* Text Content */}
          <div className="absolute left-[84px] top-[44px]">
            <h2 className="text-white text-[20px] leading-[30px] font-bold font-['Bricolage_Grotesque',_sans-serif] whitespace-nowrap">
              Debt Consolidation
            </h2>
          </div>

          <div className="absolute left-[30px] top-[81px] right-[28px] text-center">
            <p className="text-white text-[15px] leading-[18px] font-normal font-['Bricolage_Grotesque',_sans-serif]">
              Simplify to one lower monthly<br />
              payment & cut overall interest
            </p>
          </div>

          {/* Decorative coins - right-center of first card */}
          <motion.div
            className="absolute right-[8px] top-1/2 -translate-y-1/2 w-[48px] h-[30px] pointer-events-none"
            animate={{ y: [0, -3, 0], rotate: [0, 1, -1, 0] }}
            transition={{ duration: 3.2, repeat: Infinity, ease: 'easeInOut' }}
          >
            {/* Small coins */}
            <div className="absolute top-[2px] left-0">
              <div className="h-[9.053px] w-[20px] rotate-[23.681deg]">
                <Group597 />
              </div>
            </div>
            <div className="absolute top-[22px] left-[2px]">
              <div className="h-[9.052px] w-[20px] rotate-[332.548deg]">
                <Group598 />
              </div>
            </div>
            <div className="absolute top-[40px] left-[4px]">
              <div className="h-[9.052px] w-[20px] rotate-[352.239deg]">
                <Group599 />
              </div>
            </div>
            {/* Tall coin */}
            <div className="absolute top-[12px] right-0">
              <div className="h-[18.105px] w-[37px] rotate-[270.096deg]">
                <Group600 />
              </div>
            </div>
          </motion.div>
        </motion.div>
      </motion.div>

      {/* Hardship Application Card (White) */}
      <motion.div className="absolute left-[21px] top-[318px] w-[348px] h-[159px]">
        <motion.div
          className="relative w-full h-full bg-white rounded-[38.631px] border-[0.966px] border-black shadow-[5.795px_5.795px_0px_0px_#221a51]"
          initial={{ y: 10, scale: 0.98, opacity: 0 }}
          animate={{ y: 0, scale: 1, opacity: 1 }}
          transition={{ delay: 0.25, type: 'spring', stiffness: 140, damping: 12 }}
          whileHover={{ y: -2, rotate: 0.4 }}
          whileTap={{ scale: 0.995 }}
        >
          {/* Text Content */}
          <div className="absolute left-[85px] top-[40px]">
            <h2 className="text-black text-[20px] leading-[30px] font-semibold font-['Bricolage_Grotesque',_sans-serif] whitespace-nowrap">
              Hardship Application
            </h2>
          </div>

          <div className="absolute left-[52px] top-[79px] right-[52px] text-center">
            <p className="text-black text-[15px] leading-[18px] font-normal font-['Bricolage_Grotesque',_sans-serif]">
              Get a payment holiday and<br />
              lower payments temporarily
            </p>
          </div>

          {/* Profile Image */}
          <img
            src={profileImage}
            alt=""
            className="absolute right-[18px] bottom-[22px] w-[39px] h-[39px] rounded-[12.133px] object-cover"
          />
        </motion.div>
      </motion.div>

      {/* Negotiate Lower Payments Card (White) */}
      <motion.div className="absolute left-[21px] top-[512px] w-[348px] h-[159px]">
        <motion.div
          className="relative w-full h-full bg-white rounded-[38.631px] border-[0.966px] border-black shadow-[5.795px_5.795px_0px_0px_#221a51]"
          initial={{ y: 10, scale: 0.98, opacity: 0 }}
          animate={{ y: 0, scale: 1, opacity: 1 }}
          transition={{ delay: 0.35, type: 'spring', stiffness: 140, damping: 12 }}
          whileHover={{ y: -2, rotate: -0.4 }}
          whileTap={{ scale: 0.995 }}
        >
          {/* Text Content */}
          <div className="absolute left-[57px] top-[37px]">
            <h2 className="text-black text-[20px] leading-[30px] font-semibold font-['Bricolage_Grotesque',_sans-serif] whitespace-nowrap">
              Negotiate Lower Payments
            </h2>
          </div>

          <div className="absolute left-[52px] top-[76px] right-[52px] text-center">
            <p className="text-black text-[15px] leading-[18px] font-normal font-['Bricolage_Grotesque',_sans-serif]">
              Lower your interest rate and<br />
              extend your term.
            </p>
          </div>

          {/* Arrow Icon - rotated down */}
          <img
            src={arrowDown}
            alt=""
            className="absolute right-[15px] bottom-[20px] w-[37px] h-[18.105px]"
          />
        </motion.div>
      </motion.div>
    </motion.div>
  );
};

export default Screen3;
